import { h, render } from 'preact'
import App from './App'

const MOUNT_ID = 'kailani-chat-root'

// The chat renders inside a shadow root with its own stylesheet, so it looks
// the same on a WordPress page as on ours: the Divi theme cannot style into it
// and nothing in it leaks out. `data-styles` carries the stylesheet's digested
// URL, from the Rails layout or from the WordPress loader.
//
// Rendering waits for the stylesheet. An unstyled launcher is a full-width mess
// rather than a small circle, so if the stylesheet fails there is no chat on
// that page view, which is better than a broken one.
function mount() {
  const container = document.getElementById(MOUNT_ID)
  if (!container || container._preactRendered) return
  container._preactRendered = true

  const app = (
    <App
      phone={container.dataset.phone}
      phoneTel={container.dataset.phoneTel}
      sms={container.dataset.sms}
      smsTel={container.dataset.smsTel}
      email={container.dataset.email}
      redesign={container.dataset.redesign === 'true'}
    />
  )

  const href = container.dataset.styles
  if (!href || !container.attachShadow) {
    render(app, container)
    return
  }

  const root = container.attachShadow({ mode: 'open' })
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  link.addEventListener('load', () => render(app, root), { once: true })
  link.addEventListener('error', () => console.warn('[Kailani] stylesheet failed to load:', href), { once: true })
  root.appendChild(link)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount)
} else {
  mount()
}
